import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EOSAddEdit } from './Pages';

export const EOSRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EOSAddEdit} />
    </Fragment>
)